export default "__VITE_ASSET__9db1b549__$_?nuxt_component=async&nuxt_component_name=SvgoFreeusdcoin__"